import SvgIcon from '@mui/material/SvgIcon';

import { ReactComponent as CalendarSVG } from '../../assets/icons/calendar.svg';
import { ReactComponent as LocationSVG } from '../../assets/icons/location.svg';
import { ReactComponent as LogoutSVG } from '../../assets/icons/logout.svg';
import { ReactComponent as PersonSVG } from '../../assets/icons/person.svg';
import { ReactComponent as InfoSVG } from '../../assets/icons/info.svg';
import { ReactComponent as CheckMarkSvg } from '../../assets/icons/checkmark.svg';
import { ReactComponent as CloseSvg } from '../../assets/icons/close.svg';

// profile page Icons
import { ReactComponent as IdCardSvg } from '../../assets/icons/idcard.svg';
import { ReactComponent as PhoneSvg } from '../../assets/icons/phone.svg';
import { ReactComponent as MobileSvg } from '../../assets/icons/mobile.svg';
import { ReactComponent as DegreeSvg } from '../../assets/icons/degree.svg';
import { ReactComponent as ExperienceSvg } from '../../assets/icons/experience.svg';
import { ReactComponent as ResumeSvg } from '../../assets/icons/resume.svg';
import { ReactComponent as ProfileLinkSvg } from '../../assets/icons/profileLink.svg';

// Social Icons
import { ReactComponent as WhatsappSVG } from '../../assets/icons/whatsapp.svg';
import { ReactComponent as LinkedinSVG } from '../../assets/icons/linkedin.svg';
import { ReactComponent as GmailSVG } from '../../assets/icons/gmail.svg';
import { ReactComponent as MessengerSVG } from '../../assets/icons/messenger.svg';
import { fontSize } from '@mui/system';

const commonStyle = {
  display: 'inline-flex',
  padding: 4,
  boxShadow: 'rgba(0, 0, 0, 0.10) 0px 3px 8px',
  marginRight: 5,
  textAlign: 'center',
  fontSize: 'inherit',
  borderRadius: 4
};

const SocialStyle = {
  display: 'inline-flex',
  padding: 10,
  boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
  borderRadius: 4,
  marginRight: 5,
  textAlign: 'center',
  fontSize: 'inherit',
}


export const CalendarIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={CalendarSVG} viewBox='0 0 20 20' />
  </div>
);

export const LocationIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={LocationSVG} viewBox='0 0 16 16' />
  </div>
);

export const LogoutIcon = (props) => (
  <SvgIcon {...props} component={LogoutSVG} viewBox='0 0 24 24' />
);

export const PersonIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={PersonSVG} viewBox='0 0 17 17' />
  </div>
);

export const InfoIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={InfoSVG} viewBox='0 0 16 16' />
  </div>
);

export const CheckMarkIcon = (props) => (
  <SvgIcon component={CheckMarkSvg} {...props} viewBox='0 0 15 16' />
);
export const CloseIcon = (props) => (
  <SvgIcon component={CloseSvg} {...props} viewBox='0 0 15 16' />
);



// profile page Icons
// ---------------------------------------


export const IdCardIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={IdCardSvg} viewBox='0 0 24 24' />
  </div>
);
export const PhoneIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={PhoneSvg} viewBox='0 0 17 17' />
  </div>
);
export const MobileIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={MobileSvg} viewBox='0 0 30 30' />
  </div>
);

export const DegreeIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={DegreeSvg} viewBox='0 0 19 22' />
  </div>
);
export const ExperienceIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={ExperienceSvg} viewBox='0 0 18 18' />
  </div>
);
export const ResumeIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={ResumeSvg} viewBox='0 0 19 22' />
  </div>
);
export const ProfileLinkIcon = (props) => (
  <div style={commonStyle}>
    <SvgIcon {...props} component={ProfileLinkSvg} viewBox='0 0 18 18' />
  </div>
);


// Social Icons

export const WhatsappIcon = (props) => (
  <div style={SocialStyle} className={props?.className}>
    <SvgIcon {...props} component={WhatsappSVG} viewBox='0 0 34 34' />
  </div>
);

export const LinkedinIcon = (props) => (
  <div style={SocialStyle} className={props?.className}>
    <SvgIcon {...props} component={LinkedinSVG} viewBox='0 0 31 31' />
  </div>
);

export const GmailIcon = (props) => (
  <div style={SocialStyle} className={props?.className}>
    <SvgIcon {...props} component={GmailSVG} viewBox='0 0 31 31' />
  </div>
);

export const MessengerIcon = (props) => (
  <div style={SocialStyle}>
    <SvgIcon {...props} component={MessengerSVG} viewBox='0 0 32 32' />
  </div>
);